import React, { useEffect, useState } from "react";
import {
  Airplay,
  ChevronLeft,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
} from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";

import { useToast } from "../Components/toast/ToastProvider";
import Sidebar from "./Sidebar";
import Modal from "../Components/Modal";
import ContractorForm from "../Components/ContractorForm";

import {
  getAllContractors,
  saveContractor,
  updateContractor,
  deleteContractor,
} from "../Service/ContractorService";
import Footer from "../Components/Footer";

const Contractor = ({ handleLogout }) => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [contractors, setContractors] = useState([]);

  const [contractorForm, setContractorForm] = useState({
    name: "",
    contact_number: "",
  });

  const toast = useToast();

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetchContractors();
  }, []);

  const fetchContractors = async () => {
    try {
      const res = await getAllContractors();
      setContractors(res.data || []);
    } catch (err) {
      toast(err.message || "Failed to fetch contractors", "ERROR");
    }
  };

  const handleAddClick = () => {
    setContractorForm({
      name: "",
      contact_number: "",
    });

    setShowForm(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setContractorForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!contractorForm.name.trim()) {
      toast("Please enter contractor name", "ERROR");
      return;
    }

    if (!contractorForm.contact_number.trim()) {
      toast("Please enter contact number", "ERROR");
      return;
    }

    try {
      if (contractorForm.id) {
        await updateContractor(contractorForm);
        toast("Contractor updated successfully", "SUCCESS");
      } else {
        await saveContractor(contractorForm);
        toast("Contractor added successfully", "SUCCESS");
      }

      await fetchContractors();
      handleCancel();
    } catch (err) {
      toast(err.message || "Failed to save contractor", "ERROR");
    }
  };

  const handleEdit = (contractor) => {
    setContractorForm({
      id: contractor.id,
      name: contractor.name,
      contact_number: contractor.contact_number,
    });

    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this contractor?")) {
      return;
    }

    try {
      const res = await deleteContractor(id);

      if (res.success === 0 || res.success === false) {
        toast(res.message || "Unable to delete contractor", "ERROR");
        return;
      }

      toast("Contractor deleted successfully", "SUCCESS");
      await fetchContractors();
    } catch (err) {
      toast(err.message || "Failed to delete contractor", "ERROR");
    }
  };

  const handleCancel = () => {
    setContractorForm({
      name: "",
      contact_number: "",
    });

    setShowForm(false);
  };

  return (
    <div className="fixed-bottom-bar">
      <div className="osahan-trending">

        {/* Header */}
        <div className="bg-primary border-bottom p-3">
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/" className="text-white font-weight-bold">
              <ChevronLeft /> Back
            </Link>

            <Link className="toggle">
              <span
                className="toggle"
                onClick={() => setShowSideBar(true)}
                style={{ cursor: "pointer" }}
              >
                <Menu size={30} color="white" />
              </span>
            </Link>
          </div>

          <h2 className="font-weight-bold pt-3 m-0 text-white">
            Contractors
          </h2>
        </div>

        {/* Add Button */}
        <div className="d-flex justify-content-end mt-3 px-3">
          <Button
            variant="secondary"
            size="sm"
            style={{
              outline: "none",
              border: "none",
            }}
            onClick={handleAddClick}
          >
            Add
          </Button>
        </div>

        {/* Contractor Form Modal */}
        <Modal
          visible={showForm}
          size="md"
          headerText={
            contractorForm.id ? "Edit Contractor" : "Add Contractor"
          }
          onClose={handleCancel}
        >
          <ContractorForm
            contractorForm={contractorForm}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </Modal>

        {/* Contractor Cards */}
        <div className="most_popular p-3">
          <div className="row justify-content-center">
            {contractors.length === 0 ? (
              <div className="text-center text-muted py-4">
                No contractors found
              </div>
            ) : (
              contractors.map((contractor) => (
                <div
                  className="col-12 d-flex justify-content-center mb-3"
                  key={contractor.id}
                >
                  <div
                    className="card shadow-sm bill-card border-0"
                    style={{ width: "100%" }}
                  >
                    <div className="card-body p-3">

                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5
                            className="fw-bold text-muted mb-1"
                            style={{ textTransform: "capitalize" }}
                          >
                            {contractor.name}
                          </h5>

                          <small className="text-muted">
                            {contractor.contact_number}
                          </small>
                        </div>

                        <div className="d-flex gap-2">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleEdit(contractor)}
                          >
                            Edit
                          </Button>

                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDelete(contractor.id)}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Sidebar */}
        <Sidebar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          onLogout={handleLogout}
        />

        {/* Footer */}
        <Footer />

      </div>
    </div>
  );
};

export default Contractor;